<div class="content">
  <nav>
    <ul>
      <li>
        <a routerLink="/privacy-policy">Privacy Policy</a>
      </li>
      <li>
        <a routerLink="/terms-of-service">Terms of Service</a>
      </li>
      <li>
        <a routerLink="/return-and-exchange-policy">Return & Exchange Policy</a>
      </li>
    </ul>
  </nav>
</div>
